module.exports = __webpack_public_path__ + "img/mayra4.74ea407b.jpg";